import { Entity } from "common/entities/types";
import { Context } from "common/types/context";
import { EntitySetting } from "common/types/preferences";
import {
  canView,
  getAvailableUserMenuSettings,
  getUserMenuEntries,
} from "x/layout/navigation/functions";
import { EntityAction } from "./types";

export function canAccessEntity(entity: Entity) {
  return entity?.type !== "SubEntity" && !entity.isSystem;
}

function isEntityMenuItem(item: any): item is EntitySetting {
  return item && typeof item === "object" && "entity" in item;
}

export function getEntityIcons(context: Context) {
  const menuItems = getAvailableUserMenuSettings(context);

  const entityIcons: Record<string, string> = {};
  menuItems.forEach((item) => {
    if (isEntityMenuItem(item)) {
      entityIcons[item.entity] = item.icon;
    }
  });
  return entityIcons;
}

export function menuEntryForEntity(context: Context, entity: Entity) {
  const menuEntries = getUserMenuEntries(context);
  return menuEntries.find((e) => e.entityName === entity.name);
}

export function getActions(context: Context, entity: Entity): EntityAction[] {
  const menuEntry = menuEntryForEntity(context, entity);

  return [
    { id: "list", label: _("Go to List"), icon: "fa-list" },
    { id: "last-viewed", label: _("See Last Viewed"), icon: "fa-eye" },
    { id: "records", label: _("Go to Record"), icon: "fa-database" },
    {
      id: "reports",
      label: _("Go to Report"),
      icon: "fa-table",
      permissionCategory: "Reports",
    },
    {
      id: "forms",
      label: _("Go to Form"),
      icon: "fa-file",
      permissionCategory: "Forms",
    },
    {
      id: "settings",
      label: _("Go to Settings"),
      icon: "fa-cog",
      permissionCategory: "Entities",
    },
  ]
    .filter(
      (a) => !a.permissionCategory || canView(context, a.permissionCategory),
    )
    .filter((a) => a.id !== "last-viewed" || menuEntry?.lastViewedLink)
    .filter((a) => a.id !== "forms" || entity.type !== "Reference");
}
